<template>
    <div class="container">
        <h2 class="profile-page-title" v-if="!loading && !lessonRate">
            {{ $t('rate_lesson_at') }} {{ startTime }} <span class="mks-start-time" v-if="!isMskTimezone"
                                                 :title="$t('moscow_time_notice')">({{ startTimeMsk }})</span>
        </h2>

        <h2 class="profile-page-title" v-if="!loading && lessonRate">
            {{ $t('your_lesson_rate_at') }} {{ startTime }} <span class="mks-start-time" v-if="!isMskTimezone"
                                                      :title="$t('moscow_time_notice')">({{ startTimeMsk }})</span>
        </h2>

        <div class="row mt-2 justify-content-center">
            <div class="col-12 text-center" v-if="error">
                <base-alert type="danger">{{ error }}</base-alert>
            </div>
            <div class="col-12 text-center py-3" v-if="loading">
                <RippleLoader :color="'#5ab947'" :size="size" :duration="'1.5s'"/>
            </div>
            <div class="col-12 col-lg-6 text-center py-3 text-center" v-if="!loading">
                <div>
                    <star-rating
                            text-class="rate-text"
                            v-model="rating"
                            :star-size="70"
                            :read-only="readOnly"
                            inactive-color="#8b8496"
                            active-color="#ffdb00"></star-rating>
                </div>


                <div class="d-flex justify-content-center mb-3 mt-5" v-if="!lessonRate">
                    <textarea
                            rows="5"
                            class="rate-textarea flex-grow-1"
                            :placeholder="$t('share_impressions')"
                            v-model="comment"
                    ></textarea>
                </div>
                <button class="btn btn-info" type="button" @click="createRate" v-if="!lessonRate && rating > 0">
                    {{ $t('review_post') }}
                </button>
            </div>
            <div class="col-12 text-center pt-4 pb-9 lesson-nearest">

            </div>
        </div>
    </div>
</template>

<style>
    .rate-text {
        font-size: 80px;
        margin-left: 20px;
        font-family: "Manrope Bold";
    }

    .vue-star-rating {
        margin: 0 auto;
    }

    .rate-textarea {
        border-radius: 5px;
        border: 1px solid #dfdfdf;
        outline: none;
        padding: 10px 20px;
    }

    .mks-start-time {
        opacity: 0.2;
        cursor: help;
    }

    .mks-start-time:hover {
        opacity: 0.5;
    }
</style>


<script>
    import {RippleLoader} from 'vue-spinners-css';
    import StarRating from 'vue-star-rating'
    import OnlineLessonRateApi from "../../../data/OnlineLessonRateApi";
    import TimetablesApi from "../../../data/TimetablesApi";
    import userApi from "../../../data/UserApi";
    import moment from 'moment';
    import {isAuthenticated} from "@/data/jwt.service";
    import ProgressApi from "@/data/ProgressApi";

    export default {
        name: "Go",
        components: {
            RippleLoader,
            StarRating
        },
        props: {
            lessonId: {
                type: [Number, String],
            },
        },
        data() {
            return {
                loading: false,
                error: null,

                duration: 4,
                size: 220,

                rating: 0,
                comment: '',

                lesson: null,
                lessonRate: null,
                isMskTimezone: true,
            }
        },

        mounted() {
            this.loading = true
            this.isMskTimezone = userApi.isMskTimezone()
            this.fetchLesson()
            this.fetchRate()
        },

        computed: {

            startTime() {
                if (this.lesson) {
                    const str = moment(this.lesson.datetime).format('HH:mm')
                    if (this.isMskTimezone) {
                        let data = str.split(':')
                        return data[0] + ":" + data[1]
                    } else {
                        return moment(moment().format('YYYY-MM-DDT') + str + ":00.000+0300").format("HH:mm");
                    }
                }
                return null
            },

            startTimeMsk() {
                if (this.lesson) {
                    const str = moment(this.lesson.datetime).format('HH:mm')
                    if (this.isMskTimezone) return null
                    let data = str.split(':')
                    return data[0] + ":" + data[1] + "\u00A0МСК"
                }
                return null
            },

            readOnly() {
                return this.lesson != null && this.lessonRate != null
            },

        },


        methods: {
            createRate() {
                this.loading = true
                this.error = null
                const rate = {
                    rate: this.rating,
                    lesson_id: this.lessonId,
                    comment: this.comment,
                };
                OnlineLessonRateApi.createRate(rate)
                    .then(async response => {
                        this.fetchRate()
                    })
                    .catch(error => {
                        let data = (error && error.response) ? error.response.data : {}
                        this.error = this.pretty(data)
                        this.loading = false
                    })
                //10 зерен за оценку онлайн занятия
                if (isAuthenticated()) ProgressApi.addPoints(10)
            },

            fetchLesson() {
                TimetablesApi.fetchTimetableLesson(this.lessonId)
                    .then(async response => {
                        this.lesson = response
                        this.loading = false
                    })
                    .catch(error => {
                        console.log(error)
                        let data = (error && error.response) ? error.response.data : {}
                        this.error = this.pretty(data)
                        this.loading = false
                    })
            },

            fetchRate() {
                OnlineLessonRateApi.fetchRateByLessonId(this.lessonId)
                    .then(async response => {
                        this.lessonRate = response
                        if (this.lessonRate)
                            this.rating = this.lessonRate.rate
                        this.loading = false
                    })
                    .catch(error => {
                        console.log(error)
                        let data = (error && error.response) ? error.response.data : {}
                        this.error = this.pretty(data)
                        this.loading = false
                    })
            },

            pretty(value) {
                if (value && value.message) {
                    return value.message
                }
                return JSON.stringify(value, null, 2)
            },
        },

    }
</script>

